
let tmpl = require('./template.html');
const TG_FULLSCREEN_KEY = 'TG_FULLSCREEN_KEY'
adv.AdBase.extend('AdMobileMadGlobalScreenMask', {
  init(options) {
    this.base(options);

    if (window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      return false;
    }

    this.emit(adv.ENUM.EVENTS.inited);
  },
  setup(data) {
    this.data = data;
    const ignore = this.validate();
    if (!ignore) {
      this.emit(adv.ENUM.EVENTS.setuped);
    }
  },
  play() {
    const _self = this;
    let data = this.data;
    let advEl = $(this.options.selector);

    if (adv.storage.get(TG_FULLSCREEN_KEY)) {
      return;
    }

    advEl.append(adv.razor(tmpl, {
      image: data.image,
      link: data.link,
      bbsClass: window.location.hostname === 'bbs.17173.com'? 'tg-fullscreen-bbs' : '',
      advid: this.options.id
    }));

    // 添加关闭按钮点击事件
    adv.$('.tg-fullscreen .tg-fullscreen-in .tg-fullscreen-close').on('click', function() {
      adv.$('.tg-fullscreen').hide();
      _self.setStorage(TG_FULLSCREEN_KEY);
    });
    this.emit(adv.ENUM.EVENTS.played);
  },
  validate() {
    return window.location.hostname === 'news.17173.com'
    && ((window.location.href.indexOf('news.17173.com\/z\/yys') > -1 || window.location.href.indexOf('news.17173.com\/m\/z\/yys') > -1) || (window.location.href.indexOf('news.17173.com\/z\/pvp') > -1 || window.location.href.indexOf('news.17173.com\/m\/z\/pvp') > -1))
    && new Date().getTime() >= new Date('2016/12/26 00:00:00').getTime()
    && new Date().getTime() < new Date('2017/1/1 00:00:00').getTime()
  },
  setStorage(key) {
    const now = new Date();
    const todayEnd = new Date(now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + ' 23:59:59').getTime();
    adv.storage.set(key, 'ignoreThis', todayEnd - Date.now(), '17173.com', '/');
  }
})



// WEBPACK FOOTER //
// ./v1-0/production.js